import apiFetch from '../apiFetch'

export default function (idDilucion, token) {
  return apiFetch({endPoint: `Dilucion/eliminarDilucion?idDilucion=` + idDilucion, method: 'GET', body: null, token: token})
}
